export default __webpack_public_path__ + "527bc8b2874a9724623daf34870b727a.svg";